import React, { useState } from 'react';
import { Button } from '@material-ui/core';

// The one save control for the settings page.
//
// Every save looked and behaved differently before: three labels ("Submit",
// "Update Credentials", "Save Default"), two colours, and only one of them
// could tell you it was working.
//
// Green means "there is something to save". Grey means there isn't — which is
// only honest if every caller actually passes a has-changed check, so they all
// do. MUI's own disabled styling handles the grey; overriding it was fighting
// the framework to produce a button that looked pressable and wasn't.
//
// It owns its in-flight state rather than each caller tracking one, and awaits
// whatever onClick returns — so a handler that returns its promise gets a real
// "Saving…" and double-click protection for free.
const GREEN = { backgroundColor: '#4caf50', color: '#FFFFFF' };

const SaveButton = ({
  onClick,
  disabled = false,
  label = 'Save',
  busyLabel = 'Saving…',
  size = 'small',
  id,
  style,
}) => {
  const [saving, setSaving] = useState(false);
  const isDisabled = disabled || saving;

  const handleClick = async () => {
    if (isDisabled) return;
    setSaving(true);
    try {
      await onClick();
    } finally {
      // Some handlers reload the page on success, in which case this never
      // runs — harmless, and it matters for the ones that don't.
      setSaving(false);
    }
  };

  return (
    <Button
      id={id}
      variant="contained"
      size={size}
      onClick={handleClick}
      disabled={isDisabled}
      style={isDisabled ? style : { ...GREEN, ...style }}
    >
      {saving ? busyLabel : label}
    </Button>
  );
};

export default SaveButton;
